import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, throwError, EMPTY } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';

import * as CFormsSearch from '@core/custom-forms/models/field-search.model';
import * as Objects from '@core/objects';

import * as fromState from './custom-forms.state';
import * as fromRequests from './custom-forms.requests';
import * as fromActions from './custom-forms.actions';
@Injectable()
export class CustomFormsEffects {

    constructor(private actions$: Actions, private store$: Store<fromState.CustomForms>, private requests: fromRequests.CustomFormsRequests ) {}

    public loadFilters$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilters>(fromActions.CustomFormsActionType.LoadFilters),
         //withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
        switchMap((action) => {
            return [
            new fromActions.LoadFilterLabels(),
            new fromActions.LoadFilterStatus()
        ]})
    ));

    
    public loadFilterLabels$: Observable<fromActions.CustomFormsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilterLabels>(fromActions.CustomFormsActionType.LoadFilterLabels),
        switchMap((action) => {
            return this.requests.filterLabels$().pipe(
                map((labels: Objects.Label[]) => {
                    return new fromActions.LoadFilterLabelsSuccess(labels);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadFilterLabelsError(err));
                })
            );
        })
    ));

    // this load the version status list
    public loadFilterStatus$: Observable<fromActions.CustomFormsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilterStatus>(fromActions.CustomFormsActionType.LoadFilterStatus),
        switchMap((action) => {
            return this.requests.filterStatus$().pipe(
                map((status: Objects.Status[]) => {
                    return new fromActions.LoadFilterStatusSuccess(status);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadFilterStatusError(err));
                })
            );
        })
    ));

    // Data needed for components
    public loadCategories$: Observable<fromActions.CustomFormsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadCategories>(fromActions.CustomFormsActionType.LoadCategories),
        switchMap((action) => {
            return this.requests.loadCategories$().pipe(
                map((categories: Objects.LabelsGroup[]) => {
                    return new fromActions.LoadCategoriesSuccess(categories);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadCategoriesError(err));
                })
            );
        })
    ));

    public loadUsers$: Observable<fromActions.CustomFormsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadUsers>(fromActions.CustomFormsActionType.LoadUsers),
        switchMap((action) => {
            return this.requests.loadUsers$().pipe(
                map((users: Objects.User[]) => {
                    return new fromActions.LoadUsersSuccess(users);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadUsersError(err));
                })
            );
        })
    ));

    // Search 
    public applySearchFilter$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.ApplySearchFilter>(fromActions.CustomFormsActionType.ApplySearchFilter),
        switchMap((action) => [
            new fromActions.UpdateQueryParams(action.uuid)
        ])
    ));

    public removeSearchFilter$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.RemoveSearchFilter>(fromActions.CustomFormsActionType.RemoveSearchFilter),
        switchMap((action) => [
            new fromActions.UpdateQueryParams(action.uuid),
        ])
    ));

    public setSearchTerm$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SetSearchTerm>(fromActions.CustomFormsActionType.SetSearchTerm),
        switchMap((action) => [
            new fromActions.UpdateQueryParams(action.uuid)
        ])
    ));

    public updateQueryParams$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateQueryParams>(fromActions.CustomFormsActionType.UpdateQueryParams),
        withLatestFrom(this.store$.select(fromState.searchesSelector)),
        switchMap(([action, searches]) => {
            const fieldSearch = searches[action.uuid];

            if (!fieldSearch) {
                // If no search exists for this uuid, initialize one first
                return [
                    new fromActions.InitializeSearch(action.uuid),
                    new fromActions.SetQueryParams(
                        action.uuid, 
                        CFormsSearch.SearchConvert.paramsFromFilters([], '', '')
                    )
                ];
            }
            return [
                new fromActions.SetQueryParams(action.uuid, CFormsSearch.SearchConvert.paramsFromFilters(fieldSearch.search.filters, fieldSearch.search.term, fieldSearch.search.sort)),
            ]
        })
    ));

    public setQueryParams$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SetQueryParams>(fromActions.CustomFormsActionType.SetQueryParams),
        switchMap((action) => {
            return of(new fromActions.SearchArtworks(action.uuid));
         
        })
    ));

    public loadArtworkItems$: Observable<fromActions.CustomFormsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SearchArtworks>(fromActions.CustomFormsActionType.SearchArtworks),
        withLatestFrom(this.store$.select(fromState.searchesSelector)),
        mergeMap(([action, searches]) => {

            const fieldSearch = searches[action.uuid];

            if (!fieldSearch) {
                // Skip dispatching any actions if the search for the uuid doesn't exist
                return EMPTY; // RxJS constant for an empty Observable that emits nothing
            }
            return this.requests.searchArtworks$(CFormsSearch.SearchConvert.removeVoidParams(fieldSearch.search_query_params), fieldSearch.artwork_results.next_page, fieldSearch.search.limit, null).pipe(
                map((versions: Objects.Version[]) => {
                    return new fromActions.SearchArtworksSuccess(action.uuid,versions);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.SearchArtworksError(action.uuid,err));
                })
            );
        })
    ));




}
